<template>
	<div class="skeleton-wrapper">
		<div class="skeleton-all"></div>
		<div class="skeleton-title"></div>
		<div class="skeleton-content"></div>
		<div class="skeleton-loading">
			<div class="skeleton-animation"></div>
			<p class="skeleton-text">前方高能，请您耐心等待...</p>
		</div>
	</div>
</template>
<script>
export default {
	name: "skeleton",
};
</script>
<style scoped>
.skeleton-wrapper {
	height: 100vh;
	width: 100%;
	position: relative;
}
.skeleton-all {
	height: 100%;
	width: 100%;
	animation: loading-text 5s linear infinite;
	background-image: linear-gradient(
		50deg,
		#e8e7e7,
		#e8e7e7 52%,
		#f1f1f1 55%,
		#e8e7e7 58%,
		#e8e7e7
	);
	background-size: 400% 100%;
}
.skeleton-loading {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: rgba(209, 212, 210, 0.8);
	border-radius: 20px;
	box-sizing: border-box;
	padding: 20px;
}
.skeleton-animation {
	width: 200px;
	height: 200px;
	background: #fff;
	background: linear-gradient(
		to right,
		#ffffff 10%,
		rgba(255, 255, 255, 0) 50%
	);
	border-radius: 50%;
	box-shadow: inset 0 0 0 20px rgba(255, 255, 255, 0.2);
	-webkit-animation: load-effect 2s infinite linear;
	animation: load-effect 2s infinite linear;
	margin: 0 auto;
}
.skeleton-animation::before {
	position: absolute;
	width: 50%;
	height: 50%;
	content: "";
	background: rgba(255, 255, 255, 0.5);
	border-radius: 100% 0 0 0;
	left: 0;
	top: 0;
	z-index: 111;
}
.skeleton-animation::after {
	background: rgba(209, 212, 210, 0.5);
	width: 200px;
	height: 200px;
	border-radius: 50%;
	content: "";
	position: absolute;
	top: 0;
	left: 0;
}
@keyframes load-effect {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
.skeleton-text {
	color: #fff;
	margin-top: 20px;
	font-size: 26px;
}
@keyframes loading-text {
	0% {
		background-position: 400% 50%;
	}
	to {
		background-position: 0% 50%;
	}
}

.skeleton-wrapper .skeleton-title,
.skeleton-wrapper .skeleton-content {
	background: rgb(209, 212, 210);
	position: absolute;
}

.skeleton-title {
	width: 160px;
	height: 40px;
	transform-origin: left;
	animation: skeleton-stretch 0.5s linear infinite alternate;
	top: 170px;
	left: calc(50%- 80px);
}

.skeleton-content {
	width: 200px;
	height: 50px;
	margin-top: 10px;
	transform-origin: left;
	animation: skeleton-stretch 0.5s -0.3s linear infinite alternate;
	bottom: 48px;
	left: calc(50%- 100px);
}

@keyframes skeleton-stretch {
	from {
		transform: scalex(1);
	}
	to {
		transform: scalex(0.3);
	}
}
</style>
